import { render, staticRenderFns } from "./sound2.vue?vue&type=template&id=3d08a48d&scoped=true&"
import script from "./sound2.vue?vue&type=script&lang=js&"
export * from "./sound2.vue?vue&type=script&lang=js&"
import style0 from "./sound2.vue?vue&type=style&index=0&id=3d08a48d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08a48d",
  null
  
)

export default component.exports